export default __webpack_public_path__ + "static/media/Mark-2-HUD-Target Info.192db595.jpg";